import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home/Home";
import Doctor from "./Pages/Doctor/Doctor";
import Detail from "./Pages/Doctor/Detail";
import Register from "./Layout/Auth/Register";
import Login from "./Layout/Auth/Login";
import Contact from "./Pages/Contact/Contact";
import About from "./Pages/About/About";
import Forgot from "./Layout/Auth/Forgot";
import Reset from "./Layout/Auth/Reset";
import Training from "./Pages/Training/Training";
import Mission from "./Pages/Mission/Mission";
import RequestJoin from "./Pages/RequestTojion/RequestJion";
import Podcast from "./Pages/podcast/Podcast";
import Research from "./Pages/Research/Research";
import Faq from "./Pages/Faq/Faq";
import Calendar from "./Pages/Calendar/Calendar";
function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route  path="/" element={<Home />} ></Route>
          <Route  path="/practitioner" element={<Doctor />} ></Route>
          <Route  path="/details" element={<Detail />} ></Route>
          <Route  path="/register" element={<Register />} ></Route>
          <Route  path="/Login" element={<Login />} ></Route>
          <Route  path="/contact" element={<Contact />} ></Route>
          <Route  path="/Training" element={<Training />} ></Route>
          <Route  path="/Mission" element={<Mission />} ></Route>
          <Route  path="/Podcast" element={<Podcast />} ></Route>
          <Route  path="/RequestJoin" element={<RequestJoin />} ></Route>
          <Route  path="/about" element={<About />} ></Route>
          <Route  path="/forgot" element={<Forgot />} ></Route>
          <Route  path="/reset" element={<Reset />} ></Route>
          <Route  path="/research" element={<Research />} ></Route>
          <Route  path="/faq" element={<Faq />} ></Route>
          <Route  path="/calendar" element={<Calendar />} ></Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
